import { Text } from 'common-components'
import AiSkeletonItem from 'components/AISkeletonItem'
import * as Styled from './styled'
import { LoadingGradient } from 'common-components/LoadingGradient'

interface IAiGenerationLoadingContentProps {
  overlay?: boolean
  className?: string
  progress?: number | null
  message?: string | null
  aspectRatio?: string
}
export const AiGenerationLoadingContent = ({
  overlay = false,
  className,
  progress,
  message,
  aspectRatio
}: IAiGenerationLoadingContentProps) => {
  return (
    <Styled.AiGenerationLoadingContentWrapper className={className}>
      <AiSkeletonItem width="100%" height="100%" aspectRatio={aspectRatio} />
      <Styled.GenerateLoadingLabelWrapper $overlay={overlay}>
        <Styled.LoadingStateWrapper>
          <LoadingGradient progress={progress ?? null} size="large" />
        </Styled.LoadingStateWrapper>
        {message && (
          <Text type="h2" color="secondary" lineHeight="17px" align="center">
            {message}
          </Text>
        )}
      </Styled.GenerateLoadingLabelWrapper>
    </Styled.AiGenerationLoadingContentWrapper>
  )
}
